// Helper Function to get Error message

export const setScErrMsg = (temp_state) => {
    temp_state.errMsg = "";
    if (
        temp_state.topic.selectedTopic === "" ||
        (temp_state.topic.selectedTopic === "Other topic" &&
            temp_state.topic.otherTopic === "")
    ) {
        temp_state.errMsg = "Please provide topic";
    }

    if(temp_state.errMsg === "" && temp_state.details.trim()===""){
        temp_state.errMsg = "Please provide the main points"
    }

    temp_state["isGenCaptionBtnDisabled"] = temp_state.errMsg !== "";
};

export const scFormBody = ({ propState, userDetails }) => {
    const bodyobj = {
        order_id: propState["order_id"],
        prompt_type: "Facebook",
        form_schema: {},
        name: userDetails?.name || "",
        email: userDetails?.email || "",
    };

    // Caption for
    bodyobj.prompt_type = propState["captionFor"]["selectedSocialMediaOption"];

    // Topic
    if (propState["topic"]["isSelectedOthers"]) {
        bodyobj.form_schema["topic"] = propState["topic"]["otherTopic"];
    } else {
        bodyobj.form_schema["topic"] = propState["topic"]["selectedItem"];
    }

    // Description/Details
    bodyobj.form_schema["details"] = propState["details"];

    return bodyobj;
};

export const repopulate =(temp_state,data)=>{

    temp_state.order_id=data.order_id
    let form_schema=data?.form_schema
    if(data?.category){
        temp_state.captionFor.selectedSocialMediaOption=data?.category
    }
    if(form_schema?.details){
        temp_state.details=form_schema?.details
    }
    if(form_schema?.topic){
        if(temp_state.topic.dropDownList.includes(form_schema?.topic) && form_schema?.topic !== "Other topic"){
            temp_state.topic.selectedItem=form_schema?.topic
        }else{
            temp_state.topic.selectedItem="Other topic"
            temp_state.topic.otherTopic=form_schema?.topic
            temp_state.topic.isSelectedOthers=true
        }
        temp_state.topic.title = form_schema?.topic
    }
    // if(form_schema?.mainPoints){
    //     temp_state.mainPoints=form_schema?.mainPoints
    // }
    temp_state.pageType="Generated Section"
    temp_state.repopulate=true
    temp_state.captionGenerated= ScFormat(data?.descriptions)
}


// Helper fuction to check action response

export const checkActRes=(res, action)=> {
    let descObj = res?.data[action.payload.descInd];
    if (res?.status !== "success") {
        return false;
    }
    if (res?.data.length === 0) {
        return false;
    }
    if (descObj["gen_id"] !== action.payload.gen_id) {
        return false;
    }
    Object.keys(action.payload.actionInfo).forEach((actKey) => {
        if (descObj[actKey] !== action.payload.actionInfo[actKey]) {
            return false;
        }
    });

    return true;
}

// Helper function for formatting response

export const ScFormat = (responseArr) =>{
    return responseArr.map((resObj, i) => {
        // reducer description schema
        return {
            status: "Just now",
            description_generated: resObj?.description_generated || "",
            editedDesc: resObj?.description_generated || "",
            isEditing: false,
            isEdited: resObj?.is_edited || false,
            like_status: resObj?.like_status,
            generated_at: resObj?.updatedAt || "",
            gen_id: resObj.gen_id,
            rewrite_count:resObj?.rewrite_count || 0
        };
    });
}
